export const ReportType = {
    registerSummary: "RegisterSummary",
}

export enum AdHocReportType {
    Member,
    Payment
}

export enum AdhocReportStatus {
    InProgress,
    Completed,
    Failed
}